export class Icons {
  constructor(private icons: object) {}
}
